export const PLANNER_PERMISSIONS = {
  PLANT1_VIEW_JOB: "Planner_Plant1_ViewJob",
  PLANT1_MANAGE_JOB: "Planner_Plant1_ManageJob",
  PLANT3_VIEW_JOB: "Planner_Plant3_ViewJob",
  PLANT3_MANAGE_JOB: "Planner_Plant3_ManageJob",
  PLANT3_EDITABLE_COLUMN: "Planner_Plant3EditableColumn_ManageColumn",
  PROCESS_MANAGEMENT: "Planner_ProcessManagement_ManageProcesses",
  TECHNICIAN_MANAGE: "Planner_Technician_ManageTechnician",
  MACHINE_MANAGE: "Planner_Machine_ManageMachine",
} as const;
